import axios, { AxiosError, AxiosHeaders, AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import { Toast } from 'antd-mobile'

interface IAxiosRequestConfig extends InternalAxiosRequestConfig {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  getCancelMethod?: Function
}

/**
 * 提取方法和地址
 * @param config
 */
const extract = (config: IAxiosRequestConfig) => {
  // 提取方法及地址
  const urlConfig = config.url?.split(/\s+/)
  config.method = urlConfig!.length > 1 ? urlConfig![0].toLocaleLowerCase() : 'get'
  config.url = urlConfig![1]

  // 替换地址参数
  const params = config.params
  config.url = config.url?.replace(/{(\w+)}/g, (_match, $1) => {
    if (params[$1]) {
      const value = params[$1]
      delete params[$1]
      return encodeURIComponent(value)
    }
    return ''
  })
}

/**
 * 跳转登录
 * @returns
 */
const toLogin = () => {
  window.localStorage.clear()

  // const { href, pathname } = window.location

  // if (pathname !== '/login') {
  //   return window.location.replace(`/login?redirect=${encodeURIComponent(href)}`)
  // }

  const url = encodeURIComponent(
    `${process.env.API_AUTHORIZE_URL}/wechat/authorize?redirect=${encodeURIComponent(
      'https://supplier-h5.tkas2019.com/'
    )}`
  )

  window.location.replace(getAuthUrl(process.env.APP_WECHAT_ID || '', url, 'snsapi_userinfo'))
}

export const getAuthUrl = (appId: string, redirectUrl: string, scope: string = 'snsapi_base') => {
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUrl}&response_type=code&scope=${scope}&state=STATE#wechat_redirect`
}

/**
 * 校验url合法性
 * @param url
 */
const validateURL = (url: string) => {
  const regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\/[^\s]*)?$/i
  return regex.test(url)
}

/**
 * 创建请求实例
 * @param options
 */
export const createInstance = (options?: InternalAxiosRequestConfig): AxiosInstance => {
  const instance = axios.create()

  // const CancelToken = axios.CancelToken

  /**
   * 处理config
   */
  instance.interceptors.request.use((config: IAxiosRequestConfig) => {
    extract(config)

    if (options && options.baseURL && validateURL(options.baseURL)) {
      config.baseURL = options.baseURL
    }

    // 设置请求头
    if (!config.headers) {
      config.headers = {} as AxiosHeaders
    }

    config.headers['authorization'] = window.localStorage.getItem('token')
    config.headers['App-User-Id'] = window.localStorage.getItem('app-user-id')
    config.headers['App-Supplier-Id'] = window.localStorage.getItem('app-supplier-id')
    config.headers['App-Supplier-Contact-Id'] = window.localStorage.getItem('app-supplier-contact-id')

    return config
  })

  instance.interceptors.response.use(
    (response: AxiosResponse) => {
      console.log('response.data:', response.data)
      const { code, message, data } = response.data || {}

      if (code === 200) {
        return Promise.resolve(data)
      } else if (code === 401) {
        toLogin()
      } else {
        if (response.config.responseType === 'arraybuffer' || response.config.responseType === 'blob') {
          return Promise.resolve(response.data)
        }
      }

      Toast.show({
        content: message || code,
        maskClickable: false
      })
      return Promise.reject(response.data)
    },
    (error) => {
      console.log('response.error:', error)
      if (error instanceof AxiosError) {
        const { status, config = {}, response } = error as any
        switch (status) {
          case 401:
            window.localStorage.removeItem('token')
            return
          default: {
            // 取消请求时处理
            if (error.code === 'ERR_CANCELED') {
              return Promise.reject(error)
            }

            const { message } = response.data || {}
            if (!config.cancelGlobalMsg) {
              Toast.show({
                content: message || error.message,
                maskClickable: false
              })
            }

            return Promise.reject(response.data)
          }
        }
      }
      return Promise.reject(error)
    }
  )

  return instance
}
